/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/

Date.prototype.toLocalISOString = function () {
  var tzo = -this.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
  return this.getFullYear() +
    '-' + pad(this.getMonth() + 1) +
    '-' + pad(this.getDate()) +
    'T' + pad(this.getHours()) +
    ':' + pad(this.getMinutes()) +
    ':' + pad(this.getSeconds()) +
    dif + pad(tzo / 60) +
    ':' + pad(tzo % 60);
}

import Vue from 'vue';
import App from './App.vue';

import router from './router';

// Vuexy Admin Filters
import './filters/filters'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import TypeAhead from 'vue2-typeahead'
Vue.use(TypeAhead);

import VueFileUploader from './plugins/VueFileUploader'
Vue.use(VueFileUploader)

import VueI8nService from './plugins/VueI8nService'
Vue.use(VueI8nService)

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyBQl4BHWWfLbaRu5f_UQJUh77mJkPPNn9A',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import AuthService from './auth'
Vue.prototype.$AuthService = new AuthService((response) => {
  console.log("On Autenticated:", response);

  //const userRole = response.account.idTokenClaims.extension_UserRole;

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.accessToken;
  localStorage.setItem('rekom.idm.accessToken', response.accessToken);

  let redirectUrl = localStorage.getItem('rekom.idm.redirectUrl');

  localStorage.setItem('rekom.idm.isAuthed', 'true');


  if (redirectUrl) {
    router.push({ path: redirectUrl }).catch(() => { })
    return;
  }
})

import createAuthRefreshInterceptor from 'axios-auth-refresh';

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest => Vue.prototype.$AuthService.getTokenSilent().then(response => {
  if (response.tokenType === 'access_token') {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.accessToken;
    localStorage.setItem('rekom.idm.accessToken', response.accessToken);
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + response.accessToken;

    localStorage.setItem('rekom.idm.isAuthed', 'true');

    return Promise.resolve();
  } else {
    alert("You have been logged in. Trying to login again.");

    Vue.prototype.$AuthService.login(location.pathname + location.search);

    return Promise.resolve();
    //return Promise.reject();
  }
});

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic, {
  pauseInstanceWhileRefreshing: true // default: false
});

// Add a 401 response interceptor
/*axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    console.log("401: Logging in");
    //Vue.prototype.$AuthService.login(location.pathname + location.search);
  } else {
      return Promise.reject(error);
  }
});*/

Vue.config.productionTip = false

localStorage.setItem('rekom.idm.isAuthed', 'false');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (location.hash.startsWith("#state=") && localStorage.getItem('rekom.idm.accessToken')) {
  router.push({ path: "admin-home" }).catch(() => { })
}

if (location.pathname !== '/auth-redirect') {
  Vue.prototype.$AuthService.login(location.pathname + location.search);
}



/*
setInterval(() => {
  Vue.prototype.$AuthService.login(location.pathname + location.search);
}, 5*60000)*/